import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { SelectItem } from "../../models/select.model";

@Component({
  standalone: false,
  selector: 'app-sd-selector',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
  @Input()
  options: SelectItem[] = [];

  @Input()
  defaultValue?: SelectItem;

  @Input()
  showName?: boolean;

  @Output()
  valueChange = new EventEmitter<any>();

  selectedValue!: SelectItem | null;
  isOpened: boolean = false;

  @ViewChild('selectList')
  selectList!: ElementRef;

  @ViewChild('select')
  select!: ElementRef;

  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {

      if (!this.isClickedInsideSelectList(e) && !this.isClickedOnSelectButton(e)) {
        this.isOpened = false;
      }
    });
  }

  ngOnInit(): void {
    this.selectedValue = this.defaultValue ?? null;
  }

  onChange(value: SelectItem) {
    this.selectedValue = value;
    this.valueChange.emit(this.selectedValue.value);
    this.isOpened = false;
  }

  onOpen() {
    this.isOpened = !this.isOpened;
  }

  private isClickedInsideSelectList(event: any): boolean {
    let result = false;
    if (this.isOpened) {
      result = this.isInsideRectangle(event, this.selectList);
    }

    return result;
  }

  private isClickedOnSelectButton(event: any): boolean {
    return this.isInsideRectangle(event, this.select);
  }

  private isInsideRectangle(event: any, element: ElementRef): boolean {
    const rect = element.nativeElement.getBoundingClientRect();
    return ((event.x >= rect.x && event.x <= rect.x + rect.width) &&
      (event.y >= rect.y && event.y <= rect.y + rect.height));
  }
}
